// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PTeamOutlinedSvg from "@fishx/icons-svg/es/asn/PTeamOutlined";
import FishxIcon from '../components/FishxIcon';

var PTeamOutlined = function PTeamOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PTeamOutlinedSvg
  }));
};

PTeamOutlined.displayName = 'PTeamOutlined';
export default React.forwardRef(PTeamOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PTeamOutlined.js
// module id = 3677
// module chunks = 0